import * as s from "./website-black-guide-content.scss";
import {Component} from "../../../../../../../sedestral/framework/interface/component/Component";
import {WebsiteIssuesComponent} from "../../../white/issues/WebsiteIssuesComponent";
import {
    LoaderObjectBlockComponent
} from "../../../../../../components/global/loader/objects/block/LoaderObjectBlockComponent";
import {IWebsitePostModel} from "../../../../../../../models/website/posts/IWebsitePostModel";
import {Network} from "../../../../../../../network/Network";

export class WebsiteBlackGuideContentComponent extends Component {

    public article: Component;

    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackGuideContent}"></div>`;
    }

    renderContent(post: IWebsitePostModel) {
        this.clearAll();

        let extraction = this.extractContentSections(post.html);


        this.article = this.append(`
            <article itemscope itemtype="https://schema.org/BlogPosting">
                <meta itemprop="headline" content="${post.title}">
                <meta itemprop="description" content="${post.snippet}">
                <meta itemprop="datePublished" content="${new Date(post.time).toISOString()}">
                <meta itemprop="dateModified" content="${new Date(post.lastEditTime).toISOString()}">
                 <div itemprop="publisher" itemscope itemtype="https://schema.org/Organization">
                    <meta itemprop="name" content="Sedestral"/>
                    <div itemprop="logo" itemscope itemtype="https://schema.org/ImageObject">
                      <meta itemprop="url" content="${Network.vendor}images/logo-sedestral.svg" />
                    </div>
                </div>
                ${post.imageUrl ? `<div itemprop="image" itemscope itemtype="https://schema.org/ImageObject">
                    <meta itemprop="url" content="${post.imageUrl}" />
                    </div>` : ""}
                <div itemprop="author" itemscope itemtype="https://schema.org/Person">
                  <meta itemprop="name" content="Paul"/>
                </div>
                <link itemprop="mainEntityOfPage" href="${post.url}">
                <div itemprop="articleBody">${extraction.html}</div>
            </article>`);

        if (extraction.lexiqueHeading.length > 0)
            this.renderReduceSection(extraction.lexiqueHeading, extraction.lexiqueBlock);
        if (extraction.faqHeading.length > 0)
            this.article.append(extraction.faqHeading, "h2");
        if (extraction.questions.length > 0)
            this.article.render(new WebsiteIssuesComponent({theme: "guide", questions: extraction.questions}))
        if (extraction.sourcesHeading.length > 0)
            this.renderReduceSection(extraction.sourcesHeading, extraction.sourcesBlock);

        this.enableImageZoom();
    }

    renderLoader() {
        this.clearAll();

        //language=HTML
        this.append(`
            <div class="${s.loader}">
                ${this.draw(new LoaderObjectBlockComponent(true))}
            </div>
        `);
    }

    renderReduceSection(h2Html: string, html: string) {
        //language=HTML
        let title = this.article.append(`
            <div class="${s.reduce}">
                <div class="${s.head}">
                    ${h2Html}
                    <div class="${s.arrow}">
                        <div class="${s.icon}"></div>
                    </div>
                </div>
            </div>
        `);
        //language=HTML
        let content = this.article.append(`
            <div class="${s.reduceContent}">
                ${html}
            </div>
        `);

        title.onClick(() => {
            if (title.hasClass(s.open)) {
                title.removeClass(s.open);
                content.displayHide();
            } else {
                title.addClass(s.open);
                content.displayShow();
            }
        });


    }

    extractContentSections(htmlString: string) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        const result = {
            html: '',
            faqHeading: '',
            questions: [],
            sourcesHeading: '',
            sourcesBlock: '',
            lexiqueHeading: '',
            lexiqueBlock: ''
        };

        // --- 1. FAQ ---
        const faqSection = doc.querySelector('[itemscope][itemtype="https://schema.org/FAQPage"]');
        if (faqSection) {
            const h2 = faqSection.querySelector('h2');
            if (h2) result.faqHeading = h2.outerHTML;
            faqSection.querySelectorAll('[itemtype$="Question"]').forEach(qEl => {
                const q = qEl.querySelector('h3')?.textContent.trim();
                const aEl = qEl.querySelector('[itemtype$="Answer"]');
                const a = aEl ? aEl.innerHTML.trim() : '';
                if (q && a) result.questions.push({question: q, response: a});
            });
            faqSection.remove();
        }

        // --- 2. Sources ---
        const srcH2 = doc.querySelector('h2#sources');
        if (srcH2) {
            result.sourcesHeading = srcH2.outerHTML;
            let cur = srcH2.nextElementSibling;
            const buf = document.createElement('div');
            while (cur && cur.tagName.toLowerCase() !== 'h2') {
                const next = cur.nextElementSibling;
                buf.appendChild(cur);
                cur = next;
            }
            result.sourcesBlock = buf.innerHTML.trim();
            srcH2.remove();
        }

        // --- 3. Lexique SEO ---
        let lexH2 = doc.getElementById('lexique-seo');
        if (!lexH2) {
            lexH2 = Array.from(doc.querySelectorAll('h2'))
                .find(h => /lexique[-\s]*seo/i.test(h.textContent));
        }
        if (lexH2) {
            result.lexiqueHeading = lexH2.outerHTML;
            let cur = lexH2.nextElementSibling;
            const buf = document.createElement('div');
            while (cur && cur.tagName.toLowerCase() !== 'h2') {
                const next = cur.nextElementSibling;
                buf.appendChild(cur);
                cur = next;
            }
            result.lexiqueBlock = buf.innerHTML.trim();
            lexH2.remove();
        }

        // --- 4. Remove inline styles from all <table> elements and their children ---
        const tables = doc.querySelectorAll('table');
        tables.forEach(table => {
            table.removeAttribute('style');
            table.querySelectorAll('*').forEach(el => {
                el.removeAttribute('style');
            });
        });

        // --- Cleaned HTML ---
        result.html = doc.body.innerHTML.trim();
        return result;
    }

    enableImageZoom() {
        const imgs = document.querySelectorAll('img');
        imgs.forEach(img => {
            img.style.cursor = 'zoom-in';
            img.addEventListener('click', () => {
                const {top, left, width, height} = img.getBoundingClientRect();
                const scale = Math.min((innerWidth * 0.9) / width, (innerHeight * 0.9) / height);
                const tx = innerWidth / 2 - (left + width / 2);
                const ty = innerHeight / 2 - (top + height / 2);

                // clone + styles
                const clone = img.cloneNode();
                Object.assign(clone['style'], {
                    position: 'fixed',
                    top: `${top}px`,
                    left: `${left}px`,
                    width: `${width}px`,
                    height: `${height}px`,
                    zIndex: '10001',
                    borderRadius: '8px',
                    boxShadow: '0 0 40px rgba(0,0,0,0.1)',
                    objectFit: 'contain',
                    cursor: 'zoom-out',
                    transformOrigin: 'center',
                    transition: 'transform 0.3s ease'
                });

                // overlay
                const overlay = document.createElement('div');
                Object.assign(overlay.style, {
                    position: 'fixed',
                    inset: '0',
                    background: 'rgba(0,0,0,0.9)',
                    zIndex: '10000',
                    opacity: '0',
                    transition: 'opacity 0.3s ease'
                });

                document.body.append(overlay, clone);

                // zoom in
                requestAnimationFrame(() => {
                    overlay.style.opacity = '1';
                    clone['style'].transform = `translate(${tx}px,${ty}px) scale(${scale})`;
                });

                // close function (recalculate position on close)
                const close = () => {
                    overlay.style.opacity = '0';
                    const {top: t2, left: l2, width: w2, height: h2} = img.getBoundingClientRect();
                    Object.assign(clone['style'], {
                        transition: 'transform 0.3s ease, top 0.3s ease, left 0.3s ease, width 0.3s ease, height 0.3s ease',
                        transform: 'none',
                        top: `${t2}px`,
                        left: `${l2}px`,
                        width: `${w2}px`,
                        height: `${h2}px`
                    });
                    clone.addEventListener('transitionend', () => {
                        overlay.remove();
                        clone['remove']();
                    }, {once: true});
                };

                overlay.addEventListener('click', close, {once: true});
                clone.addEventListener('click', close, {once: true});
            });
        });
    }

}